import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ReactExport from "react-data-export";

import Axios from "axios"
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const _columns = {
    pos: "POS",
    round: "Round",
    product: "Product",
    agent: "Employee",
    task: "Task",
    file: "Photo",
    rate: "Rate",
    comment: "Comment",
    yesno: "Yes/No",
    quantity: "Quantity"
}

export async function GenerateReport(campaign) {
    console.time("report")
    console.log(campaign)
    if (!campaign.uid) {
        return null
    }

    const parent = campaign
    const url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + `/v1/campaigns/report/${parent.uid}`
    const query = await Axios.get(url)
    console.timeEnd("report")
    console.log(query.data)
    return { docs: query.data.payload, competition: query.data.competition }


}
export function ExportReport(props) {
    const [_rows, setRows] = useState([])

    useEffect(() => {
        setRows(props.rows)
    }, [props.rows])
    const _columns = {

        no: "NO",
        round: "Round",
        campaign_name: "Campaign Name",
        description: "Campaign Description",
        client: "Customer",
        materials: "Materials",
        pos: "POS",
        state: "State",
        city: "City",
        region: "Region",
        zipcode: "Zipcode",
        address: "Address",
        start_date: "Campaign Start Date",
        end_date: "Campaign End Date",
        timeline: "Timeline",
        cost: "Price ($)",
        payment: "Status Payment",
        number: "Payment Document",
        status: "Campaign Status",
        sku: "SKU Code",
        agent: "Employee",
        product: "SKU Description",
        phase: "Phase",
        report: "Report",
        task: "Task",
        file: "Photo",
        rate: "Rate",
        comment: "Comment",
        yesno: "Yes/No",
        quantity: "Quantity",
        write: "Date",
        write_time: "Time",
        write_year: "Year",
        write_month: "Month",
        write_day: "Day"
    }
    return (
        <ExcelFile
            filename="report"
            element={
                <Button
                    className="mx-1"
                    variant="success"
                    disabled={!_rows.length}>
                    {props.quering_results ?
                        <div className="d-flex align-items-center">
                            <div className="mr-2">Generating...</div>
                            <div className="spinner spinner-white mr-10"></div>
                        </div> : _rows.length ? "Download Report" : "No Data To Show"}
                </Button>
            }
        >
            <ExcelSheet data={_rows} name="main">
                {Object.entries(_columns).map(([value, label], key) => (
                    <ExcelColumn value={value} label={label} key={key} />

                ))}

            </ExcelSheet>
        </ExcelFile>

    )
}